<template>
  <vs-row>
     <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent" class="childImportPopUp">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
        <div slot="footer">jfjfjf</div>
      </vs-popup>
    </div>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
        <div class="collapse-item">
          <div
            class="flex justify-between header"
            slot="header"
            @click="isCollapseCard = !isCollapseCard"
            :class="{ activeCollapse: isCollapseCard }"
          >
            <h5>{{ label }}</h5>
            <span class="material-icons">keyboard_arrow_down</span>
          </div>
          <div
            class="collapseContent"
            v-show="isCollapseCard"
            :class="{ active: isCollapseCard }"
          >
            <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                <editor
                  v-if="this.$route.path == '/pages/settings'"
                  ref="tinyMce"
                  v-model="localContentValue"
                  :api-key="tinyMceApi"
                  :init="initializeTinyMce1"
                />
                <editor
                  v-else
                  ref="tinyMce"
                  v-model="localContentValue"
                  :api-key="tinyMceApi"
                  :init="initializeTinyMce"
                />
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { contentFileUpload } from '@/api/course-builderapi'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { getUploadedFilesId } from '@/api/assignment-question'

export default {
  components:{
    ImportBrowseFilesModel,
    editor: Editor

  },
  mixins:[GoogleAuthorization],
  data () {
    return {
      isBrowseContent:false,
      isCollapseCard: true,
      editorComponent:null,
      vm:{},
      // contenturl:this.image_url,
      image_url: '',
      tinyMceApi: '',
      initializeTinyMce:{

      
        setup :(editor) => {
          editor.ui.registry.addIcon('filesIcon', '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>')
          editor.ui.registry.addIcon('gDriveIcon', '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>')
          
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            classes: 'myClass',

            onAction:() => { this.importModelRepo(editor) }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
          editor.ui.registry.addButton('gDrive', {
            // text: 'Gdrive',
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction:() => { this.gDrive(editor) }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
        },
        height: 500,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
                      'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      },
      initializeTinyMce1:{

      
        setup :(editor) => {
          editor.ui.registry.addIcon('filesIcon', '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>')
          editor.ui.registry.addIcon('gDriveIcon', '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>')
          
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            classes: 'myClass',

            onAction:() => { this.importModelRepo(editor) }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
          editor.ui.registry.addButton('gDrive', {
            // text: 'Gdrive',
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction:() => { this.gDrive(editor) }

            /* onAction: () => {
              
              editor.insertContent('&nbsp;<strong>It\'s my button!</strong>&nbsp;')
            } */
          })
        },
        height: 500,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: {
          insert: { title: 'Insert', items: 'image link template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime' }
        },
        toolbar:
                      'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      }
    }
  },
  beforeMount () {
    this.vm = this
    
  },
  beforeDestroy () {
    

  },
  destroyed () {
    /*  this.$destroy() */
    
  },
  created () {
    // const customr
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API

    const customer_id = this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`
    

    // this.image_url = ' https://www.mocky.io/v2/5d4fb20b3000005c111099e3'
  },
  props: {
    label: {},
    value: {
      default: ''
    },
    file_repository_id:{}
  },

  computed: {
    localContentValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    gDrive (editor) {
      this.editorComponent = editor
      this.driveIconClicked()

    },
    images_upload_handler (blobInfo, success, failure, progress) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data = this.fileupload(formData)

      data
        .then((res) => {
          
          // const stringresponse = res.replace(/,/g, '')
          // 
          // success(JSON.stringify(res))
          

          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }

          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)
          
          // success(JSON.stringify(res))

          success(parse)
        })
        .catch((error) => {
          
        })

      // 

      // // 

      // xhr.send(formData)
    },
    async fileupload (payload) {
      try {
        const customer_id = this.$store.getters.customerId
        

        const responseImage = await contentFileUpload(customer_id, payload)

        // 
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title: 'Success',
          text: 'IMage Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        return location
      } catch (error) {
        console.warn(error)
      }
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    },
    getImportFile ({ file_id, fileInfo }) {
      
         
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="auto" height="auto"/>`)
      })
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      const res = await getUploadedFilesId(file_id_payload)
      const filesDriveInfo = res.data.data.files
      if (type === 'drive') {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split('/')[0] === 'image') {
            this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="200" height="200"/>`)
          } else if (eachFile.file_type.split('/')[0] === 'video') {
            this.editorComponent.insertContent(`<video width="200" height="300"<source src="${  eachFile.file_path  }"</video>`)
            

          } else if (eachFile.file_type.split('/')[0] === 'audio') {
            this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="200" height="200"/>`)
          }
        })
      }

    }
  }
}
</script>
<style scoped>
.childImportPopUp{
  z-index: 53001;

}
</style>